<style scoped>
    .info_page {
        background: #f7f7f7;
    }

    .info_tips {
        width: 100%;
        height: 0.36rem;
        background: #e6ebff;
        color: #5983fc;
        font-size: 0.14rem;
        text-align: center;
        line-height: 0.36rem;
    }

    .user_info {
        background: #ffffff;
    }

    .user_ingo_line {
        width: 0.04rem;
        height: 0.13rem;
        background: linear-gradient(
                135deg,
                rgba(89, 131, 252, 1) 0%,
                rgba(60, 113, 246, 1) 100%
        );
        display: inline-block;
    }

    .user_info_title {
        height: 0.42rem;
        padding: 0 0.15rem;
        display: flex;
        align-items: center;
        border-bottom: 0.01rem solid #f5f5f5;
    }

    .user_info_txt {
        margin-left: 0.06rem;
        color: #333333;
        font-weight: bold;
        font-size: 0.14rem;
    }

    .choose_user_info {
        padding: 0 0.15rem;
    }

    .user_box {
        width: 100%;
        height: 0.5rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #333333;
        font-size: 0.14rem;
    }

    .user_box_bot {
        border-bottom: 0.01rem solid #f5f5f5;
    }

    .user_box_right {
        display: flex;
        align-items: center;
    }

    .user_box_right img {
        width: 0.1rem;
        height: 0.1rem;
        margin-left: 0.1rem;
    }

    .choose_color {
        color: #999999;
    }

    >>> .van-cell {
        padding: 0.1rem 0.05rem;
        width: 80%;
    }

    >>> .van-field__control--right::-webkit-input-placeholder {
        color: #adadad;
        font-size: 0.14rem;
    }

    .income_info {
        background: #ffffff;
        margin-top: 0.1rem;
        padding-bottom: 0.3rem;
    }

    .choose_income {
        padding: 0 0.15rem;
    }

    .choose_one {
    }

    .choose_title {
        padding: 0.2rem 0 0.05rem 0;
    }

    .choose_wrap {
        display: flex;
        justify-content: space-between;
    }

    .choose_box {
        /* width: 1.08rem; */
        width: 100%;
        height: 0.3rem;
        border-radius: 0.02rem;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 0.1rem;
        border: 0.01rem solid rgba(204, 204, 204, 1);
        color: #999999;
        font-size: 0.14rem;
        text-align: center;
    }

    .cred_card {
        height: 0.48rem;
    }

    .cred_card_font {
        font-size: 0.12rem;
    }

    .cred_card_font2 {
        font-size: 0.12rem;
    }

    .click_box {
        background: rgba(79, 140, 250, 0.1);
        border: 0.01rem solid rgba(79, 140, 250, 1);
        color: #4f8cfa;
        font-weight: bold;
    }

    .last_bot {
        padding-bottom: 0.2rem;
    }

    .btn {
        /* margin-top: 0.1rem; */
        width: 100%;
        height: 0.5rem;
        background: linear-gradient(
                132deg,
                rgba(89, 163, 252, 1) 0%,
                rgba(60, 100, 246, 1) 100%
        );
        font-size: 0.17rem;
        color: #ffffff;
        font-weight: bold;
        line-height: 0.5rem;
        text-align: center;
    }

    >>> .van-col--8:nth-child(3n + 2),
    .van-col--8:nth-child(3n + 3) {
        padding-left: 0.08rem;
    }
</style>
<template>
    <div class="info_page">
        <div class="info_tips">信息仅用于审批借款额度，资料将被加密保护</div>
        <div class="user_info">
            <div class="user_info_title">
                <div class="user_ingo_line"></div>
                <span class="user_info_txt">基本信息</span>
            </div>
            <div class="choose_user_info">
                <div class="user_box user_box_bot"
                     @click="showUsePicker = true">
                    <div>借款用途</div>
                    <div class="user_box_right">
            <span v-if="useValue == ''"
                  class="choose_color">请选择</span>
                        <span v-else>{{ useValue }}</span>
                        <img src="@/assets/img/vip/right_tip.png"
                             alt=""/>
                    </div>
                </div>
                <van-popup v-model="showUsePicker"
                           round
                           position="bottom">
                    <van-picker show-toolbar
                                :columns="columnsUser"
                                @cancel="showUsePicker = false"
                                @confirm="onConfirmUser"/>
                </van-popup>
                <div class="user_box user_box_bot"
                     @click="showPerPicker = true">
                    <div>职业身份</div>
                    <div class="user_box_right">
            <span v-if="perValue == ''"
                  class="choose_color">请选择</span>
                        <span v-else>{{ perValue }}</span>
                        <img src="@/assets/img/vip/right_tip.png"
                             alt=""/>
                    </div>
                </div>
                <van-popup v-model="showPerPicker"
                           round
                           position="bottom">
                    <van-picker show-toolbar
                                :columns="columnsPer"
                                @cancel="showPerPicker = false"
                                @confirm="onConfirmPer"/>
                </van-popup>
                <div class="user_box">
                    <div>{{ showSampleTxt == true ? "月收入" : "总经营流水" }}</div>
                    <div class="user_box_right ">
                        <van-field v-model="incomeValue"
                                   placeholder="请输入"
                                   type="number"
                                   input-align="right"/>
                        <span>元/月</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="income_info"
             v-if="allList.length">
            <div class="user_info_title">
                <div class="user_ingo_line"></div>
                <span class="user_info_txt">资产信息</span>
            </div>
            <div class="choose_income">
                <div class="choose"
                     v-for="(item, index) in allList"
                     :key="index">
                    <p class="choose_title">{{ item.title }}</p>
                    <van-row>
                        <van-col span="8"
                                 v-for="(txt, num) in item.arr"
                                 :key="num">
                            <div class="choose_box "
                                 @click="clickTxt(txt, num, index)"
                                 :class="{
                  click_box: newNum[index].num == num,
                  cred_card_font: txt.length > 10,
                  cred_card: item.hasLonger == 1,
                }">
                                {{ txt }}
                            </div>
                        </van-col>
                    </van-row>
                </div>
            </div>
        </div>
        <!-- btn -->
        <div class="btn"
             @click="submit">
            提交
        </div>
    </div>
</template>

<script>
    import qs from "qs";

    export default {
        components: {},
        data() {
            return {
                useValue: "消费贷", //借款用途
                perValue: "", //身份
                showUsePicker: false,
                showPerPicker: false,
                showSampleTxt: true, //月收入
                columnsUser: [], //借款用途列表
                columnsPer: [], //职业身份列表
                incomeValue: "", //收入
                allList: [], //资产信息列表
                newNum: [],
                tips: "未完善，请填写完整后再保存~",
            };
        },
        created() {
            this.getUserInfo();
        },
        mounted() {
            this.util.title("资产信息");
        },
        methods: {
            getUserInfo() {
                //获取基本信息
                this.$get("/app/v1/xinshen/queryByXinShenList").then((res) => {
                    console.log(res.data);
                    if (res.code == 200) {
                        //借款用途
                        res.data.base_info[0].showConfig.split(",").forEach((item, index) => {
                            this.columnsUser.push({num: index, text: item});
                        });
                        //职业身份
                        res.data.base_info[1].showConfig.split(",").forEach((item, index) => {
                            this.columnsPer.push({
                                num: index,
                                text: item,
                                id: res.data.base_info[1].id,
                            });
                        });
                    } else {
                        this.util.toast({msg: res.message, type: "fail"});
                    }
                });
            },
            getList(id, name) {
                //获取资产信息
                this.$get("/app/v1/xinshen/queryByXinShenList", {
                    parentId: id,
                    assetName: name,
                }).then((res) => {
                    if (res.code == 200) {
                        let arr = [];
                        this.allList = [];
                        this.newNum = [];
                        res.data.asset_info.forEach((item, index) => {
                            this.allList.push({
                                title: item.name,
                                arr: item.showConfig.split(","),
                                hasLonger: item.hasLonger,
                            });
                            this.newNum.push({num: -1, title: item.name});
                        });
                        console.log(this.newNum);
                    } else {
                        this.util.toast({msg: res.message, type: "fail"});
                    }
                });
            },
            clickTxt(name, num, index) {
                //选择资产信息
                // console.log(name, num, index);
                this.newNum[index].num = num;
                this.newNum[index]["name"] = name;
                this.newNum[index]["num"] = this.newNum[index].num;
                console.log(this.newNum);
            },
            onConfirmUser(value) {
                //选择借款用途
                this.useValue = value.text;
                this.showUsePicker = false;
            },
            onConfirmPer(value) {
                //选择职业身份
                console.log(value);
                if (value.text == "企业主" || value.text == "个体户") {
                    this.showSampleTxt = false;
                } else {
                    this.showSampleTxt = true;
                }
                this.perValue = value.text;
                this.showPerPicker = false;
                this.getList(value.id, this.perValue);
            },
            submit() {
                //提交
                let canSubmit = true;
                if (this.useValue == "") {
                    this.util.toast({msg: "借款用途" + this.tips});
                    canSubmit = false;
                } else if (this.perValue == "") {
                    canSubmit = false;
                    this.util.toast({msg: "职业身份" + this.tips});
                } else if (this.incomeValue == "") {
                    canSubmit = false;
                    if (this.showSampleTxt) {
                        this.util.toast({msg: "月收入" + this.tips});
                    } else {
                        this.util.toast({msg: "总经营流水" + this.tips});
                    }
                } else {
                    this.newNum.forEach((item, index) => {
                        if (item.num == -1) {
                            // console.log(item, index)
                            canSubmit = false;
                            this.util.toast({msg: this.newNum[index].title + this.tips});
                        }
                    });
                }

                if (canSubmit) {
                    let assetInfoArr = [
                        {
                            key: "名下房产",
                            value: this.newNum.filter((title) => title.title == "房产情况")[0]
                                .name,
                        },
                        {
                            key: "名下车产",
                            value: this.newNum.filter((title) => title.title == "车辆情况")[0]
                                .name,
                        },
                        {
                            key: "信用卡额度",
                            value: this.newNum.filter((title) => title.title == "信用卡")[0]
                                .name,
                        },
                        {
                            key: "微粒贷额度",
                            value: this.newNum.filter((title) => title.title == "微粒贷")[0]
                                .name,
                        },
                        {
                            key: "保险保单",
                            value: this.newNum.filter((title) => title.title == "保险保单")[0]
                                .name,
                        },
                    ];
                    let baseInfoArr = [
                        {
                            key: this.showSampleTxt == true ? "月收入" : "总经营流水",
                            value: this.incomeValue,
                        },
                        {
                            //社保
                            key: "社保",
                            value: this.newNum.filter((title) => title.title == "社保")[0].name,
                        },
                        {
                            key: "公积金",
                            value: this.newNum.filter((title) => title.title == "公积金")[0]
                                .name,
                        },
                        {
                            key: "芝麻分",
                            value: this.newNum.filter((title) => title.title == "芝麻分")[0]
                                .name,
                        },
                        {
                            key: "职业身份",
                            value: this.perValue,
                        },
                    ];
                    /*if (this.perValue == "上班族" || this.perValue == "公务员" || this.perValue == "事业单位") {
                      let addParm = [
                        {
                          key: "当前单位工龄",
                          value: this.newNum.filter(
                            (title) => title.title == "当前单位工龄"
                          )[0].name,
                        },
                        {
                          key: "工资发放形式",
                          value: this.newNum.filter(
                            (title) => title.title == "工资发放形式"
                          )[0].name,
                        },
                      ];

                      addParm.forEach((item, index) => {
                        baseInfoArr.push(item);
                      });
                    } else *//*if (this.perValue == "企业主" || this.perValue == "个体户") {
          let addParm2 = [
            {
              key: "经营年限",
              value: this.newNum.filter((title) => title.title == "经营年限")[0]
                .name,
            },
            {
              key: "营业执照注册年限",
              value: this.newNum.filter(
                (title) => title.title == "营业执照注册年限"
              )[0].name,
            },
          ];
          addParm2.forEach((item, index) => {
            baseInfoArr.push(item);
          });
        }*/
                    let param = {
                        loanPurpose: this.useValue,
                        professIdentity: this.perValue,
                        monthIncome: this.incomeValue,
                        socialSecurity: this.newNum.filter(
                            (title) => title.title == "社保"
                        )[0].name,
                        creditCard: this.newNum.filter((title) => title.title == "信用卡")[0]
                            .name,
                        housSituation: this.newNum.filter(
                            (title) => title.title == "房产情况"
                        )[0].name,
                        carSituation: this.newNum.filter(
                            (title) => title.title == "车辆情况"
                        )[0].name,
                        particleBorrow: this.newNum.filter(
                            (title) => title.title == "微粒贷"
                        )[0].name,
                        operationCuration: this.newNum.filter(
                            (title) => title.title == "保险保单"
                        )[0].name,
                        accumuFund: this.newNum.filter((title) => title.title == "公积金")[0]
                            .name,
                        baseInfo: JSON.stringify(baseInfoArr),
                        assetInfo: JSON.stringify(assetInfoArr),
                    };
                    // let json = JSON.stringify(param);
                    console.log(param);
                    this.$post("/app/api/v1/authXindai", param).then((res) => {
                        console.log(res);
                        if (res.code == 200) {
                            this.authSuccess();
                        } else {
                            this.util.toast({msg: res.msg});
                        }
                    });
                }
            },
            //调用android和ios的方法
            authSuccess() {
                try {
                    window.webkit.messageHandlers.authSuccess.postMessage(""); //ios
                } catch (err) {
                    window.AppJs.authSuccess(); //android
                }
            },
        },
    };
</script>
